module.exports = __webpack_public_path__ + "img/products_4.210818f7.png";